import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@material-ui/core'
import BreadcrumbsComponent from 'src/components/BreadcrumbsComponent/BreadcrumbsComponent'
import AccentBox from 'src/components/PostGraduationContent/PostgraduateComponents/AccentBox/AccentBox'
import { postgraduatePromoBannerLenovo } from 'src/assets/images'
import { useStyles } from './PostgraduateEnrollment.styles'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'

const PostGraduateSubscriptionClosed = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const globalClasses = useGlobalStyles()

  return (
    <Box className={globalClasses.containerPages}>
      <Box className={globalClasses.topPageBreadcrumbsSearch}>
        <BreadcrumbsComponent
          crumbs={[
            { label: 'Home', path: '/news/home' },
            { label: 'Pós-Graduação', path: '/postgraduate' },
            { label: 'Inscrição' }
          ]}
        />
      </Box>
      <Box className={classes.contentWrapper}>
        <Box className={classes.header}>
          <Typography
            component="h1"
            variant="h2"
            style={{ fontWeight: 700, marginBottom: 24, color: '#1A1A1A' }}
          >
            {t('news.postgraduate.sub.page-title')}
          </Typography>
          <img
            src={postgraduatePromoBannerLenovo}
            alt="Promo banner UFC Lenovo"
            className={classes.promoImg}
          />
        </Box>
        <Box className={classes.contentContainer}>
          <Typography
            variant="h3"
            className={globalClasses.titleSectionVariant2}
          >
            {t('news.postgraduate.sub.closed.title')}
          </Typography>
          <Typography
            className={classes.paragraph}
            style={{ fontSize: '1.3rem' }}
          >
            {t('news.postgraduate.sub.closed.p1')}
          </Typography>
          <Typography className={classes.paragraph}>
            {t('news.postgraduate.sub.closed.p2')}
          </Typography>
          <Box className={classes.separator} />
          <Typography
            variant="h3"
            className={globalClasses.titleSectionVariant2}
          >
            {t('news.postgraduate.sub.contact')}
          </Typography>
          <AccentBox email="rsc@lsbd.ufc.br" />
        </Box>
      </Box>
    </Box>
  )
}

export default PostGraduateSubscriptionClosed
